// FLAGS: none
// Assessed, and clean on purpose: this renders counts and a mean duration from `counts`, never a
// roster row. Passing it an identity would be the change that moves the flag.
import { Card, CardContent } from "@openup/shared/primitives/ui/card";
import { SessionAttendance } from "@src/models/spaces";
import { formatDuration } from "@src/utils/format";

interface AttendanceSummaryProps {
  counts: SessionAttendance["counts"];
}

interface TileProps {
  label: string;
  /** Null renders the "available after the session" empty state. */
  value: number | null;
  formatValue?: (value: number) => string;
}

const Tile = ({ label, value, formatValue }: TileProps) => (
  <Card>
    <CardContent className="flex flex-col gap-1 p-4">
      <p className="text-sm text-gray-500">{label}</p>
      {value === null ? (
        <p className="text-sm text-gray-400">Available after the session</p>
      ) : (
        <p className="text-2xl font-semibold text-indigo-800">
          {formatValue ? formatValue(value) : value}
        </p>
      )}
    </CardContent>
  </Card>
);

/**
 * Six summary tiles. Registration counts are known today; the attendance
 * outcomes (attended, no-show, average time) show an empty state until the
 * session has run and Zoom attendance is ingested (S5).
 */
const AttendanceSummary = ({ counts }: AttendanceSummaryProps) => (
  <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
    <Tile label="Invited" value={counts.invited} />
    <Tile label="Registered" value={counts.registered} />
    <Tile label="Cancelled" value={counts.cancelled} />
    <Tile label="Attended" value={counts.attended} />
    <Tile label="No-show" value={counts.noShow} />
    <Tile
      label="Avg. time"
      value={counts.avgDurationSeconds}
      formatValue={formatDuration}
    />
  </div>
);

export default AttendanceSummary;
